import {getFormat} from 'colord';
import {z} from 'zod';

import {addSlug} from '../../functions/slugify';

export const categoryAiModels = [
  ['steel-corrosion', 'Steel corrosion'],
  ['concrete-crack', 'Concrete crack'],
  ['asphalt-crack', 'Asphalt crack'],
  ['concrete-spalling', 'Concrete spalling'],
  ['staining', 'Steel staining'],
  ['coating-breakdown', 'Coating breakdown'],
  ['corrosion-staining', 'Corrosion + staining'],
];

const modelKeys = categoryAiModels.map(([key]) => key) as [string, ...string[]];

export const categorySchema = z
  .object({
    id: z.string(),
    name: z.string(),
    colour: z.string().refine((colour) => getFormat(colour) === 'hex', {
      message: 'Colour is not a hex code',
    }),
    model: z.enum(modelKeys).nullable(),
    modified: z.coerce.date(),
    isArchived: z.boolean().catch(false),
    isAssetArchived: z.boolean().nullable().catch(null),
  })
  .transform(({isArchived, isAssetArchived, ...category}) => ({
    ...category,
    isArchived: isArchived || !!isAssetArchived,
  }))
  .transform(addSlug);
